import apiClient from '@/api/client'
import { Dictionary, SubscriptionFormInputs } from '@/types/field'
export default class SubscriptionAPI {

    // User API
    static subscriptionList(payload: Dictionary) {
        return apiClient.post('/subscription/list', payload)
    }

    static subscriptionById(id: string) {
        return apiClient.get('/subscription/list/' + id)
    }

    static subscriptionCreate(payload: SubscriptionFormInputs) {
        return apiClient.post('/subscription/create', payload)
    }

    static subscriptionUpdate(payload: Dictionary) {
        return apiClient.post('/subscription/update', payload)
    }
    static subscriptionDelete(id: string) {
        return apiClient.delete(`/subscription/delete/${id}`)
    }
    static subscriptionStatusUpdate(payload: Dictionary) {
        return apiClient.post('/subscription/update/status', payload)
    }
}
